/* eslint-disable css-modules/no-unused-class  */
import { FC, useState } from 'react';
import { Icon, Button } from 'common-components';
import { MenuItem, ListItemText, ListItemIcon } from '../../uiLibraryImports';
import styles from './optionList.module.scss';
import { useTranslationContext } from '../../contexts/translationContext';

const MenuItemWrapper: FC<MenuItemProps> = (props: MenuItemProps) => {
    const { key, text, icon, onClick, showAnswerOptions, onClose } = props;
    const [isSelected, setIsSelected] = useState(false);

    const { translate } = useTranslationContext();

    const onItemClicked = () => {
        if (showAnswerOptions) {
            setIsSelected(!isSelected);
        } else {
            onClick();
            onClose();
        }
    };

    const onApprove = () => {
        onClick();
        onClose();
    };

    return (
        <MenuItem
            className={styles['menu-item']}
            key={key}
            onClick={() => onItemClicked()}
            sx={{
                '&:hover': {
                    background:
                        'linear-gradient(83deg,rgba(226, 216, 247, 0.4) 2.82%,rgba(242, 125, 177, 0.05) 52.7%,rgba(226, 216, 247, 0.4) 94.71%)'
                },
                boxShadow:
                    'box-shadow: 8px 8px 16px 0px rgba(222, 222, 245, 0.7), -8px -8px 16px 0px rgba(222, 222, 245, 0.7)',
                marginLeft: '0.5rem !important',
                marginRight: '0.5rem !important',
                borderRadius: '6px !important',
                background: isSelected
                    ? 'linear-gradient(83deg,rgba(226, 216, 247, 0.4) 2.82%,rgba(242, 125, 177, 0.05) 52.7%,rgba(226, 216, 247, 0.4) 94.71%)'
                    : undefined,
                paddingTop: '0.5rem !important',
                paddingBottom: '0.5rem !important',
                paddingLeft: '0.6875rem !important',
                paddingRight: '0.6875rem !important'
            }}
        >
            <div className={styles.wrapper}>
                <div className={styles[isSelected ? 'top-selected' : 'top-wrapper']}>
                    <ListItemIcon>
                        <Icon name={icon} className={styles.icon} />
                    </ListItemIcon>
                    <ListItemText className={styles.text}>{text}</ListItemText>
                </div>
                {isSelected && (
                    <div className={styles['actions-wrapper']}>
                        <hr />
                        <div className={styles['buttons-wrapper']}>
                            <Button
                                type="learningPanelAdminActionButton"
                                onClick={onClose}
                                text={translate('Cancel')}
                                lowerCase
                            />
                            <Button
                                type="learningPanelAdminActionButton"
                                onClick={onApprove}
                                text={translate('Approve')}
                                lowerCase
                            />
                        </div>
                    </div>
                )}
            </div>
        </MenuItem>
    );
};

export default MenuItemWrapper;

export interface MenuItemProps {
    key: string;
    text: string;
    icon: string;
    onClick: Function;
    showAnswerOptions?: boolean;
    onClose: Function;
}
